import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import style from './css/nav.module.css';
import { HamburgetMenuClose, HamburgetMenuOpen } from './Icons';
import logo from '../assets/Aptech_Logo.png';

function Nav() {
    const [click, setClick] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const location = useLocation();

    const handleClick = () => setClick(!click);
    const handleDropdownToggle = () => setShowDropdown(!showDropdown);

    useEffect(() => {
        window.scrollTo(0, 0);
        const { hash } = location;
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        setClick(false);
        setShowDropdown(false);
    }, [location.pathname]);

    return (
        <nav className={style.navBar}>
            <div className={style.navContainer}>
                <NavLink exact="true" to="/" className={style.navLogo}>
                    <img src={logo} alt="Aptech Logo" className={style.navLogoImage} />
                </NavLink>

                <ul className={click ? `${style.navMenu} ${style.active}` : style.navMenu}>
                    <li className={style.navItem}>
                        <NavLink exact="true" to="/" className={({ isActive }) => isActive ? `${style.active} ${style.navLinks}` : style.navLinks} onClick={handleClick}>Home</NavLink>
                    </li>
                    <li className={style.navItem}>
                        <NavLink exact="true" to="/about" className={({ isActive }) => isActive ? `${style.active} ${style.navLinks}` : style.navLinks} onClick={handleClick}>About Us</NavLink>
                    </li>

                    {/* Courses Dropdown */}
                    <li className={`${style.navItem} ${style.dropdown}`}>
                        <span className={style.navLinks} onClick={handleDropdownToggle}>
                            Courses ▾
                        </span>
                        <ul className={`${style.dropdownMenu} ${showDropdown ? style.dropdownOpen : ''}`}>
                            <li><NavLink to="/courses/career" className={style.dropdownLink} onClick={handleClick}>Career Courses</NavLink></li>
                            <li><NavLink to="/courses/short-term" className={style.dropdownLink} onClick={handleClick}>Short-term Courses</NavLink></li>
                            <li><NavLink to="/courses/professional" className={style.dropdownLink} onClick={handleClick}>Professional Courses</NavLink></li>
                            <li><NavLink to="/courses/japawithadse" className={style.dropdownLink} onClick={handleClick}>JAPA with ADSE</NavLink></li>
                        </ul>
                    </li>

                    <li className={style.navItem}>
                        <NavLink exact="true" to="/contact" className={({ isActive }) => isActive ? `${style.active} ${style.navLinks}` : style.navLinks} onClick={handleClick}>Contact Us</NavLink>
                    </li>
                    <li className={style.navItem}>
                        <NavLink exact="true" to="/events" className={({ isActive }) => isActive ? `${style.active} ${style.navLinks}` : style.navLinks} onClick={handleClick}>Events</NavLink>
                    </li>
                    <li className={style.navItemLast}>
                        <NavLink exact="true" to="/apply" className={({ isActive }) => isActive ? `${style.active} ${style.navLinks}` : style.navLinks} onClick={handleClick}>Apply</NavLink>
                    </li>
                </ul>

                <div className={style.navIcon} onClick={handleClick}>
                    {click ? (
                        <span className={style.icon}><HamburgetMenuClose /></span>
                    ) : (
                        <span className={style.icon}><HamburgetMenuOpen /></span>
                    )}
                </div>
            </div>
        </nav>
    );
}

export default Nav;
